import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Requisitions/Items'

export default createChildListViewContainer()(Component)
